export default {
  SET_PROPOSAL_DATA({ commit }, payload) {
    commit('SET_PROPOSAL_DATA', payload);
  },
  SET_FILTERS({ commit }, payload) {
    commit('SET_FILTERS', payload);
  },
  UPDATE_FILTERS({ commit }, payload) {
    commit('UPDATE_FILTERS', payload);
  },
  SET_FILTER_SEARCHED({ commit }, payload) {
    commit('SET_FILTER_SEARCHED', payload);
  },
  RESET_FILTERS({ commit }) {
    commit('RESET_FILTERS');
  },
};
